import type { StoreData } from "@components/store-locator/controller";
import type { Cart } from "@graphql/generated/types";
import type { SimpleMoneyData } from "@ui/components/data-display/money/useMoney";

export const checkClickAndCollectAvailability = (cart: Cart, storeData: StoreData) => {
    if (!cart?.lineItems?.length || !storeData?.supplyChannel?.[0]?.id) {
        return false;
    }

    return cart.lineItems.every((item) =>
        item?.variant?.availability?.channels?.results?.some(
            (variant) =>
                variant?.channel?.id === storeData.supplyChannel[0].id &&
                variant.availability.isOnStock
        )
    );
};

export const calculateDisplayPrices = (
    isOmnibusMarket: boolean,
    currentPrice: number,
    discountPercentage: number,
    previousLowestPrice: SimpleMoneyData,
    discountPreviousLowest: number,
    recommendedPrice: SimpleMoneyData
) => {
    const isDiscounted = discountPercentage > 0;

    if (!isDiscounted) {
        return {
            displayPreviousPrice: previousLowestPrice,
            displayDiscountPercentage: discountPreviousLowest,
        };
    }

    if (!isOmnibusMarket) {
        return {
            displayPreviousPrice: previousLowestPrice,
            displayDiscountPercentage: discountPercentage,
        };
    }

    if (!!previousLowestPrice?.centAmount) {
        if (previousLowestPrice?.centAmount > currentPrice) {
            return {
                displayPreviousPrice: previousLowestPrice,
                displayDiscountPercentage: discountPreviousLowest,
            };
        }

        return {
            displayPreviousPrice: null,
            displayDiscountPercentage: 0,
        };
    }

    return {
        displayPreviousPrice: recommendedPrice,
        displayDiscountPercentage: discountPercentage,
    };
};
